import type { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environment/environment';

/**
 * HTTP interceptor that handles impersonated requests.
 * When a user is impersonating another user, this interceptor adds the necessary
 * impersonation headers (ImpersonatingUser and CustomerId) to API requests.
 *
 * Reads impersonation state directly from localStorage to avoid circular dependency
 * with UserService.
 */
export const userImpersonationInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  if (req.url.includes(environment.APIBase)) {
    // Read impersonation state directly from localStorage to avoid circular dependency
    const customerId = localStorage.getItem('customerId');
    const userSubject = localStorage.getItem('userSubject');

    // If impersonating (customerId exists in localStorage), add headers
    if (customerId) {
      const newReq = req.clone({
        setHeaders: {
          ImpersonatingUser: userSubject ?? '',
          CustomerId: customerId ?? '',
        },
      });
      return next(newReq);
    }
  }

  return next(req);
};
